import _ from 'lodash';
import { FilterValueObject, FilterValueType } from '../containers/search-filters/types';

export const parseSearchParams = (urlSearchParams: URLSearchParams): FilterValueObject => {
  const params: FilterValueObject = {};
  urlSearchParams.forEach((value, key) => {
    const isObjectTypeKeyRegex = /\w+\[\w+\]$/g; // Regex to check: if word contains "some-key[any-word]" pattern
    const isObjectType = isObjectTypeKeyRegex.test(key);

    if (isObjectType) {
      const parentKey = _.toPath(key)[0];
      const valueKey = _.toPath(key)[1];
      const currentParam = params[parentKey];
      if (!currentParam) {
        params[parentKey] = {
          [valueKey]: value,
        };
      } else {
        if (typeof currentParam === 'object' && !Array.isArray(currentParam)) {
          params[parentKey] = {
            ...currentParam,
            [valueKey]: value,
          };
        } else {
          params[parentKey] = {
            [valueKey]: value,
          };
        }
      }
    } else {
      const isArrayType = key.endsWith('[]');
      const parsedKey = isArrayType ? key.slice(0, -2) : key;
      if (params[parsedKey]) {
        const currentParam = params[parsedKey];
        if (Array.isArray(currentParam)) {
          params[parsedKey] = [...currentParam, value];
        } else {
          if (typeof currentParam !== 'object') {
            params[parsedKey] = [currentParam, value];
          }
        }
      } else {
        if (isArrayType) {
          params[parsedKey] = [value];
        } else {
          params[parsedKey] = value;
        }
      }
    }
  });
  return params;
};

export const formatSearchParams = (
  params: Record<string, FilterValueType | undefined>
): Record<string, string | string[]> => {
  const usedParams: Record<string, string | string[]> = {};
  _.forIn(params, (value, key) => {
    if (value) {
      if (Array.isArray(value)) {
        const arrValue = value.filter((val) => val.toString().trim().length > 0);
        usedParams[`${key}[]`] = arrValue.map((value) => value.toString());
      } else {
        if (typeof value === 'object') {
          _.forIn(value, (itemValue, itemKey) => {
            if (itemValue && itemValue.toString().trim().length > 0) {
              usedParams[`${key}[${itemKey}]`] = itemValue;
            }
          });
        } else {
          if (value.toString().trim().length > 0) {
            usedParams[key] = value.toString();
          }
        }
      }
    }
  });
  return usedParams;
};

export const queryStringify = (params: FilterValueObject | undefined, prefix?: string): string | undefined => {
  if (params && typeof params === 'object') {
    const pairs: (string | undefined)[] = [];
    for (const key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) {
        continue;
      }

      const value = params[key];
      const encodedKey = encodeURIComponent(key);
      let pair: string | undefined;
      const newPrefix = prefix ? prefix + '[' + encodedKey + ']' : encodedKey;
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          pair = value.map((valueItem) => `${newPrefix}[]=${encodeURIComponent(valueItem)}`).join('&');
        } else {
          pair = queryStringify(value, newPrefix);
        }
      } else {
        pair = newPrefix + '=' + encodeURIComponent(value);
      }
      pairs.push(pair);
    }
    return pairs.join('&');
  }
  return undefined;
};
